import { useEffect, useState } from "react";
import { useDrawerTransition } from "../../context/drawerProvider";
import { loadData } from "../../config/data";
import { useSelector } from "react-redux";
import Lang from "../../config/lang";

const SearchFooter = () => {
    const [keywords, setkeywords] = useState('');
    const { lang } = useSelector((state) => state.globalReducer);
    const { startTransition } = useDrawerTransition();
    const [jobListTotal, setJobListTotal] = useState(0);

    const loadJobata = async () => {
        const now = new Date();
        const formattedDate = now.toISOString().split("T")[0].slice(0, 10);
        loadData({
            url: `Jobs`,
            params: [{ title: 'date', value: formattedDate }],
        }).then(async res => {
            if (res?.data) {
                setJobListTotal(res?.total)
            }
        })
    };

    useEffect(() => {
        loadJobata();
    }, [])

    return (
        <div className="mt-10 md:mt-28 py-4 min-h-[300px] md:min-h-[480px] w-full relative" style={{ backgroundImage: 'linear-gradient(160deg, #7BB3F4 5%, #F1F5F9 20%, #7BB3F4 100%)' }}>
            <div className="pt-8 md:pt-14" />
            <p className='text-[#48494B] text-[28px] md:text-[72px] w-[80%] md:w-full mx-auto font-normal leading-tight text-center relative z-10'>{lang === 'en' && 'Your '}<b className='text-[#034694] font-semibold'>{lang === 'en' ? 'next' : 'Langkah baru'}</b> {lang === 'en' ? 'move starts' : 'Anda dimulai'} <b className='text-[#EA2427] font-semibold'>{Lang(lang, 'here')}</b></p>
            <p className='text-[#48494B] text-[15px] md:text-[22px] font-normal leading-tight text-center pt-2 md:pt-8 relative z-10'><b>{jobListTotal}</b> {Lang(lang, 'jobs_are_available')}</p>
            <div className="w-[80%] md:w-[50%] 2xl:w-[38%] mx-auto pt-6 md:pt-12 max-w-[1000px] relative z-50">
                <div className='relative'>
                    <div className="absolute inset-y-0 start-0 flex items-center ps-6 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>

                    <input type="search" id="default-search" className="block w-full p-3 md:p-4 ps-14 md:ps-14 pe-12 md:pe-16 text-sm md:text-base text-gray-900 border border-gray-300 rounded-[35px] bg-[#FFFFFF]" placeholder={Lang(lang, 'search_job_hint_footer')} required style={{ boxShadow: '0px 0px 15px 2px rgba(0, 118, 255, 0.15)' }}
                        onChange={(e) => {
                            setkeywords(e.target.value);
                        }}
                        onKeyUp={(e) => {
                            if (e.key === "Enter" && keywords) {
                                startTransition(`/${lang}/portal?search=${keywords}`);
                            }
                        }} />
                    {/* <button type="submit" className="text-white absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Search</button> */}
                    <div className='absolute end-2 bottom-[10px] md:bottom-1.5' onClick={() => {
                        startTransition(`/${lang}/portal?search=${keywords}`);
                    }}>
                        <img src="/asset/submitBtn.png" className="w-[25px] h-[25px] md:w-[45px] md:h-[45px]" />
                    </div>
                </div>
            </div>
            <div className="absolute top-0 right-0 opacity-[.4]">
                <img src="/asset/logo_white.svg" className="w-[60%] ml-auto md:w-full" />
            </div>
        </div>
    )
}

export default SearchFooter;